<template>
  <div>
    <FieldsetBox>
      <template #header v-if="showHeader">
        <div style="width: 50%; margin: -3em auto auto auto; background: #fff;">
          <SVGHotelBuilding />
        </div>
      </template>
      <template #content>
        <SmallHotelItinerary :journey="sol"></SmallHotelItinerary>
      </template>
      <template #footer>
        <b-button  size="is-small"
                   type="normal"
                   @click="checkDelete()"
                   icon-right="delete"
                   inverted
                   class="ml-1"
        />
        <b-button  size="is-small"
                   type="normal"
                   @click="ok()"
                   icon-right="pencil"
                   inverted
                   class="ml-1"
        />
      </template>
    </FieldsetBox>
</div>
</template>

<script>
  import SmallHotelItinerary from './SmallHotelItinerary.vue';
  import FieldsetBox from "../UI/FieldsetBox";
  import SVGHotelBuilding from "../SVGs/SVG-HotelBuilding";

  export default {
      name: 'ItineraryHotel',
      components: {
        SmallHotelItinerary,
        FieldsetBox,
        SVGHotelBuilding,
      },
      props: {
        sol: Object,
        showHeader: {
          type: Boolean,
          default: true,
        }
      },
      data: function () {
        return {
        }
      },
      methods: {
        ok() {
            this.$emit('add')
        },
        checkDelete(){
            this.$buefy.dialog.confirm({
                message: 'Are you sure you would like to delete this hotel from your itinerary?',
                confirmText: 'Delete',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.del()
            })

        },
        del(){
          this.$store.dispatch('bookTravel/alterHotelResult', {})
        },
      }
    }
</script>

<style scoped>
</style>
